var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-0 pa-0",attrs:{"flat":""}},[_c('v-card-text',{staticClass:"pa-4 pl-4"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }